var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanvasAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 3.16667V1.83333C22.6667 1.1 22.0667 0.5 21.3333 0.5H18.6667C17.9333 0.5 17.3333 1.1 17.3333 1.83333V3.16667H16V8.5C16 9.23333 16.6 9.83333 17.3333 9.83333H18.6667V19.1667C18.6667 20.6333 17.4667 21.8333 16 21.8333C14.5333 21.8333 13.3333 20.6333 13.3333 19.1667V5.83333C13.3333 2.88667 10.9467 0.5 8 0.5C5.05333 0.5 2.66667 2.88667 2.66667 5.83333V15.1667H1.33333C0.6 15.1667 0 15.7667 0 16.5V21.8333H1.33333V23.1667C1.33333 23.9 1.93333 24.5 2.66667 24.5H5.33333C6.06667 24.5 6.66667 23.9 6.66667 23.1667V21.8333H8V16.5C8 15.7667 7.4 15.1667 6.66667 15.1667H5.33333V5.83333C5.33333 4.36667 6.53333 3.16667 8 3.16667C9.46667 3.16667 10.6667 4.36667 10.6667 5.83333V19.1667C10.6667 22.1133 13.0533 24.5 16 24.5C18.9467 24.5 21.3333 22.1133 21.3333 19.1667V9.83333H22.6667C23.4 9.83333 24 9.23333 24 8.5V3.16667H22.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasAdmin);
export default __webpack_public_path__ + "static/media/canvas-admin.9a30be40c08aad6a41acd4303bd4581c.svg";
export { ForwardRef as ReactComponent };